import { USER_OPTIONS } from "../../config/constants.js";
import { ClearPhone } from "../items/view.js";

export class UserPublicView {
  constructor() {

  }

  renderMain(_user) {
    if (!_user) {
      _user = {};
    }

    let location = _user.city || '';
    if (location && _user.state) {
      location += ', ' + _user.state;
    }


    let occupation = USER_OPTIONS.Cargos.find(i => i.value == _user.occupation)?.text || '';
    if (occupation.startsWith('--') || occupation.indexOf('--')) {
      occupation = '';
    }

    let mensaje = `Hola ${_user.name}, vi tu perfil en agrolabores.com y necesito hablar con vos.`;

    return `
      <div class="user-header">
        <div class="profile">
          <div class="image" style="background-image: url(${_user.image}), url(/assets/img/user.jpg)" onclick="user.ImagePreview()"></div>
          <div class="text">
            <div class="title">${_user.name || ''}</div>
            <div class="description">
              ${occupation || ''}
              <br>
              ${location}
            </div>
          </div>
        </div>
        <nav class="actions">
          <a href="https://wa.me/${ClearPhone(_user.phone)}?text=${mensaje.replace(/ /g, '%20')}"
              class="whatsapp" target="_blank">Escribir al Whatsapp</a>
          <a href="callto:${ClearPhone(_user.phone)}" class="phone">Llamar al ${_user.phone}</a>
        </nav>
      </div>
      <div id="user-content" class="items">
        <div>
          <h1>Cargando publicaciones</h1>
          <div id="gallery-loading" class="loader gray"></div>
        </div>
      </div>
    `;
  }

}
